import { Image, ImageProps } from "@chakra-ui/react";

export function ServeCredLogo(props: ImageProps) {
  return (
    <Image
      width="80%"
      h="auto"
      src="/assets/layout/images/servecred-logo.png"
      {...props}
    />
  );
}
